// src/pages/Pageformality/request.jsx
import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "api";
import { debug, formatDate } from "utils";
import { useSelector, useDispatch } from "react-redux";
import FormBuilderRender from "components/formbuilder/FormBuilderRender";
import FormBuilderSummary from "components/formbuilder/FormBuilderSummary";
import { FormBuilderRenderContext } from "components/formbuilder/FormBuilderRenderContext";
import { FormBuilderOpenDocument } from "components/formbuilder/utils/DocumentsUtils";
import UserSignInModal from "components/user/UserSignInModal";
import FormalityRequestPaymentModal from "components/formalities/modals/FormalityRequestPaymentModal";
import FormalityRequestSummaryModal from "components/formalities/modals/FormalityRequestSummaryModal";
import FormalityRequestCustomName from "components/formalities/helpers/FormalityRequestCustomName";
import InvoiceBillingInfoModal from "components/orders/modals/InvoiceBillingInfoModal";
import { getValueByPath, setValueByPath } from 'components/formalities/utils/utils';

import useRNE from "components/rne/useRNE";
import RNEInfo from "components/rne/RNEInfo";
import { loadCart } from '../../redux/cartSlice';
import Swal from 'sweetalert2';
import CMSBlock from 'components/cms/CMSBLock';
import "css/info-blocks.css";
export default function PageFormalityRequest() {
  const { tplId, reqId } = useParams();
  const navigate = useNavigate();
  const templateRef = useRef(null);
  const sirenRef = useRef('');
  const [requestId, setRequestId] = useState(reqId || null);
  const [schema, setSchema] = useState(null);
  const [request, setRequest] = useState(null);
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDirty, setIsDirty] = useState(false);
  const [error, setError] = useState(null);
  const [saveSignal, setSaveSignal] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  // const [formDataInitial, setFormDataInitial] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [readyForValidation, setReadyForValidation] = useState(false);
  const [attestRequestIsAccurate, setAttestRequestIsAccurate] = useState(false);
  const [analysis, setAnalysis] = useState(null);
  const [pendingSave, setPendingSave] = useState(null);
  const [showSignInModal, setShowSignInModal] = useState(false);
  const [userModalOptions, setUserModalOptions] = useState({ onSuccess: () => setShowSignInModal(false), userType: 'cust' });
  const [step, setStep] = useState("form");
  const [customName, setCustomName] = useState("");
  const [fbTopButtons, setFBTopButtons] = useState([]);
  const [fbBottomlButtons, setFBBottomlButtons] = useState([]);
  const [fbStatusInfo, setFBStatusInfo] = useState(null);
  const [checkedSiren, setCheckedSiren] = useState('');
  const [showStripeModal, setShowStripeModal] = useState(false);
  const [order, setOrder] = useState(null);
  const [showFormalityRequestSummary, setShowFormalityRequestSummary] = useState(false);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [isLastTab, setIsLastTab] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const fbIsAdmin = false;
  const { rneData, checkSiren, rneShowInfo } = useRNE();
  useEffect(() => {
    const handlePopState = (event) => {



      const stepFromHistory = event.state?.step;
      if (stepFromHistory === "intro") {
        setStep("intro");
        return;
      }
      if (stepFromHistory === "form") {
        setStep("form");
        return;
      }
      // fallback : on laisse le navigateur faire son travail
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  useEffect(() => {
    if (template?.ftId) {
      templateRef.current = template;
    }
  }, [template]);
  useEffect(() => {
    setRequest(prev => ({ ...prev, frCustomName: customName }));
  }, [customName])
  useEffect(() => {

  }, [request])
  useEffect(() => {
    const hydrateFromProfile = async () => {
      if (!user.isSignedIn) return;
      if (!request) return;
      // On hydrate uniquement en création ou draft
      if (request.frStatus !== 'draft') return;
      const res = await api.get('/user/profile');
      const profileData = {
        prenom: res.data.userFirstname,
        nom: res.data.userName,
        telephone: res.data.userPhone || null,
        email: res.data.userEmail,
      };
      setRequest(prev => {
        const currentTab = prev.frData?.tab_intro || {};
        const mergedTab = { ...currentTab };
        Object.keys(profileData).forEach(key => {
          const currentValue = currentTab[key];
          const isEmpty =
            currentValue === undefined ||
            currentValue === null ||
            currentValue === '';
          if (isEmpty) {
            mergedTab[key] = profileData[key];
          }
        });
        return {
          ...prev,
          frData: {
            ...prev.frData,
            tab_intro: mergedTab,
          }
        };
      });
    };
    hydrateFromProfile();
  }, [user.isSignedIn]);
  function mergeDeep(target, source) {
    for (const key in source) {
      if (
        source[key] &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key])
      ) {
        if (!target[key]) {
          target[key] = {};
        }
        mergeDeep(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
    return target;
  }
  // ------------------------------------------------------
  // CHARGEMENT DES DONNÉES
  // ------------------------------------------------------
  useEffect(() => {
    const load = async () => {
      try {
        if (requestId) {
          const res = await api.get(
            `/formalities/request/${requestId}?withTemplate=1`
          );
          if (!res?.data) {
            throw new Error("Aucune réponse du serveur");
          }
          const _request = res.data;

          if (!_request.template) {
            throw new Error("Template manquant");
          }
          if (!_request.template.format) {
            throw new Error("Template.format ou schéma manquant");
          }
          if (!_request.template.format.schema) {
            throw new Error("Template.format.schema manquant");
          }
          setCustomName(_request.frCustomName);
          setTemplate(_request.template);
          setAnalysis(_request.frAnalysis);
          if (_request.order?.orderId) {
            setOrder(_request.order);
          }
          let ready = false;
          if (_request.frStatus === 'draft' && _request.validation?.validated) {
            ready = true;
          }
          if (_request.frStatus === 'validated') {
            ready = true;
          }
          if (_request.frStatus === 'waiting') {
            if (_request.frIsCompliant) {
              ready = true;
            }
          }

          setReadyForValidation(ready);
          setSchema(_request.template.format.schema);
          setRequest(_request);
          setIsReadOnly(!["draft", "waiting"].includes(_request.frStatus));
          setIsCompleted(_request.frStatus === "completed");
          if (
            _request.frStatus === 'waiting'
          ) {
            let content = "<div class='mb-2 text-danger'>Cette demande est en attente d'informations complémentaires.</div>"
            content += "<div class='mb-2'>Une fois les corrections apportées, veuiller enregistrer les modifications<br />puis sur cliquer sur «Valider»</div>"
            content = content
            setFBStatusInfo({
              content: content,
              visible: true,
              className: 'text-dark'
            });
            setFBTopButtons(prev => [
              ...(prev ?? []),
              {
                label: "Valider",
                onClick: (e => { handleSave(); setReadyForValidation(true) }),
                className: 'btn-outline-danger',
                disabled: false, // Suppose une sauvagarde avant de pouvoir valider
                visible: true,
              }
            ]);
          }
          if (!res.data.validation?.validated) {
            setValidationErrors(res.data.validation.errors);
          } else {
            setValidationErrors({});
          }
          setRequest(_request);
          return;
        }
        if (tplId) {
          const initialData = {}
          if (user.isSignedIn) { // on charge le tab tab_intro avec les data du user
            const res = await api.get('/user/profile');
            initialData.tab_intro = {
              'prenom': res.data.userFirstname,
              'nom': res.data.userName,
              'telephone': res.data.userPhone || null,
              'email': res.data.userEmail,
            }
          }
          const res = await api.get(`/formalities/template/${tplId}`);
          if (!res?.data?.schema) {
            throw new Error("Aucun schéma trouvé");
          }
          setTemplate(res.data);
          setSchema(res.data.schema);
          // setForm___DataInitial(initialData);
          // 👉 merge ici
          if (res.data.preDefinedsValues) {
            mergeDeep(initialData, res.data.preDefinedsValues);
          }
          setRequest({ frData: initialData, frStatus: 'draft', frCustomName: res.data.ftName });
          setCustomName(res.data.ftName)
          setIsReadOnly(false);
          setIsCompleted(false);
          if (!requestId && tplId) {
            window.history.replaceState(
              { step: "intro" },
              "",
              window.location.pathname
            );
          }
          setStep("intro"); // 👈 écran d’accueil en création
          return;
        }
        throw new Error("Paramètres invalides");
      } catch (err) {
        console.error("Erreur FormRequest :", err);
        setError("Impossible de charger la formalité.");
      } finally {
        setLoading(false);
      }
    };
    load();
    setFBTopButtons([{
      label: "Enregistrer",
      onClick: handleSave,
      visible: true,
    }]);
  }, [tplId, requestId]);
  const goToForm = () => {
    window.history.pushState(
      { step: "form" },
      "",
      window.location.pathname
    );
    setStep("form");
  };
  // ------------------------------------------------------
  // TAB CHANGE
  // ------------------------------------------------------
  const handleFBTabChange = async (data) => {


    setIsLastTab(data.activeTabIndex >= data.tabsLength - 1);
    let saveResult = null;
    if (user.isSignedIn) {
      if (isDirty || data.activeTabIndex === data.tabsLength) {
        saveResult = await handleSave(data.formData);

      }
      if (data.activeTabIndex === data.tabsLength) {
        if (saveResult === true) {
          setReadyForValidation(true);
        } else {
          Swal.fire({
            title: 'Formulaire incomplet',
            html: '<p>Certains champs sont manquants<br />ou contiennent des erreurs.</p>',
            confirmButtonText: 'OK',
            customClass: {
              confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false
          });
          setReadyForValidation(false);
        }
      }
    }
  };
  const handleSigninSuccess = async (data) => {
    setShowSignInModal(false);
  }
  const handleSave = useCallback(async (data) => {
    if (!user.isSignedIn) {
      setPendingSave(data);
      setUserModalOptions({
        ...userModalOptions,
        onSuccess: (data) => handleSigninSuccess(data),
        signUp_defaults: {
          userFirstname: data?.tab_intro?.prenom,
          userName: data?.tab_intro?.nom,
          userEmail: data?.tab_intro?.email,
          userPhone: data?.tab_intro?.telephone,
        }
      });
      setShowSignInModal(true);

    }
    const currentTemplate = templateRef.current;
    try {
      let res;
      if (requestId) {
        // mise à jour
        res = await api.put(`/formalities/request/${requestId}`, {
          frData: data,
        });
      } else {
        // création
        res = await api.post(`/formalities/request`, {
          frTemplateId: currentTemplate.ftId,
          frCustomName: customName,
          frData: data,
        });
        if (res?.data?.frId) {
          setRequestId(res.data.frId);
          window.history.replaceState(
            {},
            "",
            `/formalities/request/${res.data.frId}`
          );
        }
      }
      setRequest({ ...request, ...res.data });
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Demande enregistrée",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      });

      if (res?.data?.frStatus === 'draft') {
        if (!res?.data?.validation?.validated) {
          setReadyForValidation(false);
          setValidationErrors(res.data.validation.errors);
        } else {
          if (isLastTab) {
            // setReadyForValidation(true);

          }
          setValidationErrors({});
        }
      }
      if (
        res?.data?.frStatus === 'waiting'
      ) {
        const fbTopButtonsCopy = [...fbTopButtons];
        if (fbTopButtonsCopy[1]) {
          fbTopButtonsCopy[1].disabled = false;

          setFBTopButtons([...fbTopButtonsCopy]);
        }
      }

      setSaveSignal(Date.now());
      setIsDirty(false);

      return res?.data?.validation?.validated;
    } catch (e) {
      console.error("SAVE ERROR", e);
    }
  }, [
    user.isSignedIn,
    userModalOptions,
    handleSigninSuccess,
    requestId,
    request,

  ]);
  const handleFBChange = async (data) => {




    setRequest(prev => ({
      ...prev,
      frData: data,
    }));
    setReadyForValidation(false)
    setIsDirty(true);
  };
  const handleFBCtrlBlur = async (ev) => {
    const { name, value } = ev.target;
    if (name === 'siren' && /^[\d\s]+$/.test(value)) { // on ne traite pas les siren fictif de création
      let next = value.replace(/[^0-9]/g, '')
      const updatedData = {
        ...request.frData,
        tab_informations_societe: {
          ...request.frData.tab_informations_societe,
          siren: next
        }
      };
      if (next.length === 9 && next != checkedSiren) {
        const res = await checkSiren(next);
        setCheckedSiren(next);

      }
      setRequest(prev => ({
        ...prev,
        frSiren: next,
        frData: updatedData,
      }));
    }



  }
  // ------------------------------------------------------
  // Auto-save après login
  // ------------------------------------------------------
  useEffect(() => {
    if (user.isSignedIn && pendingSave) {
      handleSave(pendingSave);
      setPendingSave(null);
    }
  }, [user.isSignedIn, pendingSave, handleSave]);
  // ------------------------------------------------------
  // VALIDATION
  // ------------------------------------------------------
  const handleValidate = useCallback(async () => {
    if (['draft', 'waiting'].includes(request.frStatus)) {
      if (!attestRequestIsAccurate) {
        const baseText = "Merci de bien vouloir ";
        const text =
          request.frStatus === 'waiting'
            ? baseText + "confirmer que les corrections requises ont été apportées."
            : baseText + "attester que les informations fournies sont exactes.";
        Swal.fire({
          title: "Action impossible",
          text,
          showConfirmButton: true,
          confirmButtonText: "OK",
        });
        return;
      }
      if (request.frStatus === 'draft') {
        try {
          const res = await api.post(`/formalities/request/${requestId}/validate`, {
            attestRequestIsAccurate
          });
          if (res.data?.validation?.validated === false) {
            Swal.fire({
              text: "La demande ne peut être validée car des champs requis sont manquants",
              icon: undefined,   // aucune icône
              confirmButtonText: "OK"
            });
            setValidationErrors(res.data.validation.errors);
            setReadyForValidation(false);
            return;
          }
          if (res.data?.order) {
            setOrder(res.data.order);
            setShowBillingModal(true);
          }
          if (res.data?.request) {
            setRequest(prev => ({
              ...prev,
              frStatus: res.data.request.frStatus,
              frOrderId: res.data.request.frOrderId,
              frSubmittedAt: res.data.request.frSubmittedAt
            }));
          }
        } catch (e) {

          Swal.fire({
            title: "Action impossible",
            text: e.response.data.error.message,
            showConfirmButton: true,
            confirmButtonText: "OK",
          });
          return;
        }
      }
      if (request.frStatus === 'waiting') {
        await api.post(`/formalities/request/${requestId}/resubmission`);
        Swal.fire({
          title: "Information transmise",
          text: "Fortium Formalités a été informé que les corrections requises ont été apportées.",
          showConfirmButton: true,
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/customer/account/formalities");
        });
      }
      dispatch(loadCart());
    }
  }, [request?.frStatus, attestRequestIsAccurate, customName]);
  // ------------------------------------------------------
  // MEMO
  // ------------------------------------------------------
  const formMeta = useMemo(() => {
    if (!template) return null;
    return {
      id: template.ftId,
      title: template.ftName,
      description: template.ftSummary || "",
      layout: template.ftLayout,
      // signaux fonctionnels neutres
      pricing: template.ftTotalPriceET,
      isReadOnly,
      isCompleted,
    };
  }, [template, isReadOnly, isCompleted]);
  const memoValidationErrors = useMemo(
    () => validationErrors,
    [validationErrors]
  );
  const fbOpenDocument = useCallback(
    async (file, field) => {
      try {
        let res;
        // --- Cas 1 : édition (formalités existantes) ---
        if (requestId) {
          res = await api.post(
            `/formalities/request/${requestId}/document/open`,
            {
              file: {
                path: file.path,
                name: file.name,
                mime: file.mime,
                size: file.size,
              },
              field: {
                name: field.name,
                parents: field.parents || [],
                type: field["x-ui"],
              },
            },
            { responseType: "blob" }
          );
        }
        // --- Cas 2 : création (document temporaire FormBuilder) ---
        else {
          res = await FormBuilderOpenDocument(file.path);
        }
        // --- Ouverture du document ---
        const url = URL.createObjectURL(res.data);
        window.open(url, "_blank", "noopener");
        // --- Nettoyage ---
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 10_000);
      } catch (e) {
        console.error("OPEN DOCUMENT ERROR", e);
      }
    },
    [requestId]
  );
  const fbDeleteDocument = useCallback(
    async (file, field) => {
      try {
        const conf = await Swal.fire({
          title: 'Confirmation',
          html: `Confirmez-vous la suppression du document<br /><strong>« ${file.name} »</strong>&nbsp;?`,
          showCancelButton: true,
          confirmButtonText: 'Oui, supprimer',
          cancelButtonText: 'Annuler',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-danger me-2',
            cancelButton: 'btn btn-outline-secondary',
          },
        });
        if (!conf.isConfirmed) return;
        const path = [
          ...(field.parents || []),
          field.name,
        ];
        const prevValue = getValueByPath(request.frData, path);
        const newValue = prevValue.filter(it => it.path !== file.path);
        const next = setValueByPath(
          structuredClone(request.frData),
          path,
          newValue
        );

        // Mise à jour UNIQUE
        setRequest(prev => ({
          ...prev,
          frData: next,
        }));
        setIsDirty(true);
      } catch (e) {
        console.error('DELETE DOCUMENT ERROR', e);
      }
    },
    [requestId, request]
  );
  const handleBillingSaved = (updatedOrder, paymentMode) => {
    setOrder(updatedOrder);
    setShowBillingModal(false);
    setShowStripeModal(true);
  };
  /*
  */
  // ------------------------------------------------------
  // AFFICHAGE
  // ------------------------------------------------------
  if (loading) return <div>Chargement…</div>;
  if (error) return <div className="text-danger">{error}</div>;
  return (
    <div className="py-4">
      {step === "intro" && (
        <div className="mb-5">
          <CMSBlock
            blockId="page-formality-request-intro"
            titleTag="h2"
            contentsClassName="container"
          />
          <div className="container text-center">
            <div className="form-group mx-auto mb-5" style={{ maxWidth: '500px' }} >
              <label className="form-label text-primary">Veuillez donner un nom à votre demande :</label>
              <input
                type="text"
                className="form-control rounded-pill text-center bg-primary-10"
                name="frCustomName"
                value={customName}
                onChange={e => setCustomName(e.target.value)} />
            </div>
            <button
              className="btn btn-primary btn-lg rounded-pill"
              onClick={goToForm}
              disabled={!customName?.trim()}
            >
              Commencer la formalité
            </button>
          </div>
        </div>
      )}
      {step === "form" && (
        <div className="container">
          {readyForValidation === false ? (
            <div>
              <div className="d-flex align-items-center justify-content-center gap-2">
                <FormalityRequestCustomName
                  request={request}
                  isReadOnly={isReadOnly}
                  requestId={requestId}
                  onChange={(name) => setCustomName(name)}
                />
              </div>
              <FormBuilderRenderContext.Provider value={{ fbOpenDocument, fbDeleteDocument, fbIsAdmin }}>
                <FormBuilderRender
                  externalSchema={schema}
                  meta={formMeta}
                  onSave={handleSave}
                  onChange={handleFBChange}
                  onCtrlBlur={handleFBCtrlBlur}
                  onTabChange={handleFBTabChange}
                  saveSignal={saveSignal}
                  formDataInitial={request?.frData || {}}
                  validationErrors={memoValidationErrors}
                  isReadOnly={isReadOnly}
                  analysis={analysis}
                  topButtons={fbTopButtons}
                  bottomsButtons={fbBottomlButtons}
                  statusInfo={fbStatusInfo}
                />
              </FormBuilderRenderContext.Provider>
            </div>
          ) : (
            <div className="text-center py-5">
              {request.frStatus === 'draft' &&
                <div>
                  <div className="pb-5" >
                    <h2 className="fs-5 text-primary">Votre demande est complète et peut être validée.</h2>
                  </div>
                  <div className="mx-auto mb-4" style={{ maxWidth: '96%', width: '450px' }}>
                    <div class="mt-4 py-3 px-3 rounded-pill border text-start alert alert-primary d-flex gap-2 justify-content-center align-items-start">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="chk-confirm"
                        value={attestRequestIsAccurate}
                        onClick={e => setAttestRequestIsAccurate(e.target.checked)}
                      />
                      <label for="chk-confirm" class="form-check-label">
                        J’atteste que les informations fournies sont exactes.
                      </label>
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-md-row gap-md-5 gap-4 justify-content-center align-items-center">
                    <button className="btn btn-outline-primary rounded-pill" onClick={e => setReadyForValidation(false)}>Modifier ma demande</button>

                    <button className="btn  btn-danger rounded-pill" onClick={handleValidate}>Valider ma demande</button>
                  </div>
                </div>
              }
              {request.frStatus === 'waiting' && <div>
                <div className="mx-auto mb-4" style={{ maxWidth: '96%', width: '450px' }}>
                  <p>
                    <strong>Votre demande va maintenant être de nouveau instruite par Fortium Formlités.</strong>
                  </p>
                  <div class="mt-4 py-3 px-3 rounded-pill border text-start alert alert-primary d-flex gap-2 justify-content-center align-items-start">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="chk-confirm"
                      value={attestRequestIsAccurate}
                      onClick={e => setAttestRequestIsAccurate(e.target.checked)}
                    />
                    <label for="chk-confirm" class="form-check-label">
                      J’atteste que toutes les corrections requises ont été apportées à ma demande.
                    </label>
                  </div>
                </div>
                <div className="d-flex gap-5 justify-content-center">
                  <button className="btn  btn-sm  btn-outline-primary rounded-pill" onClick={e => setReadyForValidation(false)}>Modifier ma demande</button>
                  <button className="btn btn-outline-primary rounded-pill" onClick={e => navigate('/customer/account')}>Mes demandes</button>
                  <button className="btn  btn-sm btn-danger  rounded-pill" onClick={handleValidate}>Valider ma demande</button>
                </div>
              </div>
              }
              {(request.frStatus === 'validated') && <div>
                <div className="mx-auto mb-4" style={{ maxWidth: '96%', width: '450px' }}>
                  <p>
                    <strong>Demande validée en attente de réglement</strong>
                  </p>
                  <p class="mt-4 py-3 px-3 rounded-pill border text-center alert alert-primary d-flex gap-2 justify-content-center align-items-start">
                    Cette demande a été validée le {formatDate(request.frSubmittedAt)}< br />et est en attente de réglement.
                  </p>
                </div>
                <div className="d-flex gap-5 justify-content-center">
                  <button className="btn btn-sm btn-outline-primary rounded-pill" onClick={e => setShowFormalityRequestSummary(true)}>Afficher ma demande</button>
                  <button className="btn  btn-danger  rounded-pill" onClick={() => navigate("/cart")}>Aller au panier</button>
                </div>
              </div>
              }
            </div>
          )
          }
        </div>
      )}
      {/* MODAL LOGIN */}
      <UserSignInModal
        show={showSignInModal}
        options={userModalOptions}
        onClose={() => setShowSignInModal(false)}
      />
      {/* ★★ MODAL PAIEMENT FACTORISÉE ★★ */}
      {showStripeModal && (
        <FormalityRequestPaymentModal
          show={showStripeModal}
          requestId={requestId}
          onPaid={() => navigate("/customer/account/formalities")}
          onClose={() => setShowStripeModal(false)}
        />
      )}
      {showBillingModal &&
        <InvoiceBillingInfoModal
          show={showBillingModal}
          order={order}
          onClose={() => setShowBillingModal(false)}
          onSaved={handleBillingSaved}
          enablePaymentOptions={true}
          enableProfileInfo={true}
        />
      }
      {showFormalityRequestSummary &&
        <FormalityRequestSummaryModal
          show={showFormalityRequestSummary}
          requestId={request.frId}
          onClose={() => setShowFormalityRequestSummary(false)}
        />
      }
      {rneShowInfo &&
        <RNEInfo
          data={rneData}
          onConfirm={(rneData) => {
          }}
          onCancel={() => {
          }}
        />
      }
    </div>
  );
}
